// src/constants/translations.ts
import { en } from './lang/en';
import { id } from './lang/id';

export const translations = {
  en,
  id
};
